// extracted by mini-css-extract-plugin
module.exports = {"secondary-title":"SecondaryTitle_secondary-title__2cUCw","secondary-title__content":"SecondaryTitle_secondary-title__content__16cq0"};